import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ParcelPackage, ParcelProduct } from "@/types/api/api-types";

const InformationDisplay = ({
  label,
  value,
  bold,
  key,
}: {
  label: string;
  value: string;
  bold?: boolean;
  key?: string;
}) => {
  return (
    <div className="items-top flex flex-row gap-2" key={key}>
      <p className={cn("w-fit min-w-fit text-sm text-gray-900", bold && "font-bold")}>{label} :</p>
      <p className={cn("text-sm text-gray-900", bold && "font-bold")}>{value}</p>
    </div>
  );
};

export const ParcelProductInfo = ({
  parcelProduct,
  index,
}: {
  parcelProduct: ParcelProduct;
  index: number;
}) => {
  const { t } = useTranslation("boQuotations");
  if (parcelProduct.type === "BOTTLE") {
    return (
      <InformationDisplay
        label={t("quoteProducts.parcelLabel", { number: index + 1 })}
        value={t("quoteProducts.bottles", {
          quantity: parcelProduct.bottleQuantity,
          volume: parcelProduct.volume,
        })}
        key={`parcel-product-${index}`}
      />
    );
  }
  return (
    <InformationDisplay
      label={t("quoteProducts.parcelLabel", { number: index + 1 })}
      value={`${parcelProduct.description}`}
      key={`parcel-product-${index}`}
    />
  );
};

export const ParcelPackageInfo = ({
  parcelPackage,
  index,
}: {
  parcelPackage: ParcelPackage;
  index: number;
}) => {
  const { t } = useTranslation("boQuotations");
  return (
    <>
      <InformationDisplay
        label={t("quoteProducts.parcelLabel", { number: index + 1 })}
        value={t("quoteProducts.dimensions", {
          length: parcelPackage.length,
          width: parcelPackage.width,
          height: parcelPackage.height,
          weight: parcelPackage.weight,
        })}
        key={`parcel-package-${index}`}
      />
      <InformationDisplay
        label={t("quoteProducts.parcelLabel", { number: index + 1 })}
        value={`${parcelPackage.value} €`}
        key={`parcel-package-value-${index}`}
      />
    </>
  );
};
